import { Fragment } from 'react';
import { Box, Stack } from '@mui/material';
import { ControlledInputs } from '@/components';
import { useSendEmailFormContext } from '../hooks/use-send-email.form.context';

export const ForgotPasswordFormField = () => {
  const form = useSendEmailFormContext();
  return (
    <Fragment>
      <Box display="flex" justifyContent="center">
        <Stack spacing={2} sx={{ width: 280 }}>
          <ControlledInputs.TextField
            placeholder="Enter your email address"
            ControllerProps={{
              control: form.control,
              name: 'email',
            }}
          />
        </Stack>
      </Box>
    </Fragment>
  );
};
